import {isNullOrUndefined} from "../../../common/utils";
import {Operators} from "../model/Operators";

export function findSpecialConditionByUserId(conditionNode, userId) {
    if (isNullOrUndefined(conditionNode)) {
        return null;
    }
    if (conditionNode.operator === Operators.comparisonSPECIAL_EQ
        && conditionNode.getOperands().attributeValueToBeMatched === userId) {
        return conditionNode;
    }
    if (conditionNode.isSingleOperand() === false) {
        let foundNode;
        const operands = conditionNode.getOperands();
        for (let count = 0; count < operands.length; count++) {
            foundNode = findSpecialConditionByUserId(operands[count], userId);
            if (!isNullOrUndefined(foundNode)) {
                return foundNode;
            }
        }
    }
    return null;
}
